const TasksVolumetryHome: React.FC = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_555_29612)" />
      <path
        d="M40.6814 48.4999C38.0952 48.4999 35.5091 48.4999 32.9229 48.4999C31.9531 48.4999 31.091 47.8533 30.8755 46.9913C30.5523 45.6982 31.5221 44.459 32.8151 44.459C35.1319 44.459 37.4487 44.459 39.7654 44.459C42.6749 44.459 45.6382 44.459 48.5476 44.459C49.4635 44.459 50.3256 45.1594 50.4872 46.0215C50.7027 46.9374 50.2717 47.9072 49.4097 48.2843C49.0864 48.446 48.7092 48.4999 48.386 48.4999C45.9076 48.4999 43.2675 48.4999 40.6814 48.4999Z"
        fill="white"
      />
      <path
        d="M40.7353 28.4573C38.1492 28.4573 35.563 28.4573 32.9769 28.4573C31.7915 28.4573 30.8756 27.5952 30.8756 26.4099C30.8756 25.2785 31.7915 24.3625 32.9769 24.3625C38.1492 24.3625 43.3754 24.3625 48.5477 24.3625C49.6792 24.3625 50.4873 25.1168 50.649 26.1944C50.7567 27.2181 50.1102 28.134 49.0326 28.4034C48.871 28.4573 48.7093 28.4573 48.5477 28.4573C45.9077 28.4573 43.3215 28.4573 40.7353 28.4573Z"
        fill="white"
      />
      <path
        d="M40.7353 34.1684C43.3754 34.1684 45.9615 34.1684 48.6015 34.1684C49.5714 34.1684 50.4334 34.9227 50.595 35.8386C50.7567 36.8623 50.2179 37.8321 49.1942 38.1015C48.9787 38.2093 48.7632 38.2093 48.5477 38.2093C43.3215 38.2093 38.0953 38.2093 32.8691 38.2093C31.7915 38.2093 30.9295 37.4011 30.8217 36.3235C30.7139 35.2998 31.4144 34.3839 32.4919 34.1684C32.6536 34.1145 32.8152 34.1145 32.9768 34.1145C35.563 34.1684 38.1492 34.1684 40.7353 34.1684Z"
        fill="white"
      />
      <path
        d="M22.9555 25.1707C23.7098 24.4164 24.3563 23.6621 25.0567 22.9617C25.38 22.6384 25.6494 22.3151 25.9727 21.9919C26.6192 21.3453 27.5351 21.3453 28.1817 21.938C28.8282 22.5306 28.8282 23.5005 28.2356 24.147C26.9964 25.494 25.7572 26.787 24.518 28.0801C23.4404 29.2116 21.824 29.0499 20.9081 27.7568C20.4771 27.1103 20.0461 26.4638 19.615 25.8172C19.1301 25.009 19.2918 24.0931 20.0461 23.6082C20.7465 23.1233 21.7163 23.3388 22.2551 24.0931C22.4706 24.4164 22.6861 24.7935 22.9555 25.1707Z"
        fill="white"
      />
      <path
        d="M23.1709 38.263C24.3016 38.263 25.2183 37.3463 25.2183 36.2156C25.2183 35.0849 24.3016 34.1682 23.1709 34.1682C22.0402 34.1682 21.1235 35.0849 21.1235 36.2156C21.1235 37.3463 22.0402 38.263 23.1709 38.263Z"
        fill="white"
      />
      <path
        d="M23.1709 48.5C24.3016 48.5 25.2183 47.5834 25.2183 46.4526C25.2183 45.3219 24.3016 44.4053 23.1709 44.4053C22.0402 44.4053 21.1235 45.3219 21.1235 46.4526C21.1235 47.5834 22.0402 48.5 23.1709 48.5Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_555_29612"
          x1="34.5455"
          y1="2.70945e-07"
          x2="34.5455"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EA1225" />
          <stop offset="1" stopColor="#BA0B1B" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default TasksVolumetryHome
